import React, { useState, useCallback, useEffect, FunctionComponent, useRef } from 'react';
import Video, { createLocalAudioTrack, createLocalVideoTrack } from 'twilio-video';
import { GlobalVars } from '../libs/utils';
import Room from './Room';
import './VideoChat.css';

interface Props {
  live: boolean;
  user?: any;
}

const VideoChat: FunctionComponent<Props> = ({ live, user }) => {
  const [room, setRoom] = useState<any>(null);
  const [timer, setTimer] = useState<number>(0);
  const mounted = useRef<boolean>(false);
  //const [connecting, setConnecting] = useState(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  });

  useEffect(() => {
    return () => {
      if (GlobalVars.admin && GlobalVars.socket && room) {
        try {
          const url = `https://twilio.alive.vision/rooms/${room.sid}?status=completed`;
          //const url = `http://localhost:3600/rooms/${room.sid}?status=completed`;
          fetch(url, {
            method: 'POST',
          });
        } catch (error) {
          console.error(error);
        }
      }
    };
  }, [room]);

  useEffect(() => {
    const id = Math.floor(Math.random() * 1000000000 + 1);
    //setConnecting(true);
    let localVideoTrack: any;
    let localAudioTrack: any;

    const getData = async () => {
      const url = 'https://twilio.alive.vision/video/token';
      //const url = 'http://localhost:3000/video/token';
      const data = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          identity: (GlobalVars.identity ? GlobalVars.identity : 'Admin') + '-user' + id,
          room: 'room-' + GlobalVars.room,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json());
      Video.connect(data.token, {
        name: 'room-' + GlobalVars.room,
        tracks: [],
      })
        .then(async (room: any) => {
          if (user && user.data.trialSpecs.active) {
            //mounted.current && setTimer(user.data.trialSpecs.maxMeetingMinutes * 60);
            mounted.current && setTimer(0.5 * 60);
          }
          if (GlobalVars.socket) {
            const participantsLimit = user?.data.trialSpecs.active
              ? user.data.trialSpecs.maxMeetingUsers
              : 1000;
            GlobalVars.socket.emit('participantsLimit', participantsLimit);
          }
          try {
            localVideoTrack = await createLocalVideoTrack();
          } catch (e) {
            console.error(e);
          }
          try {
            localAudioTrack = await createLocalAudioTrack();
          } catch (e) {
            console.error(e);
          }
          localVideoTrack && (await room.localParticipant.publishTrack(localVideoTrack));
          localAudioTrack && (await room.localParticipant.publishTrack(localAudioTrack));

          mounted.current && setRoom(room);
          /*room.on('disconnected', () => {
            const closeCallEvent = new Event('closeCall');
            window.dispatchEvent(closeCallEvent);
          });*/
        })
        .catch((err) => {
          console.log(err);
          GlobalVars.reset();
          //console.error(err);
          //setConnecting(false);
        });
    };

    getData();

    return () => {
      localVideoTrack && localVideoTrack.stop();
      localAudioTrack && localAudioTrack.stop();
    };
  }, [user]);

  useEffect(() => {
    if (user && user.data.trialSpecs.active && room) {
      if (timer >= 0) {
        setTimeout(() => {
          mounted.current && setTimer(timer - 1);
        }, 1000);
      } else {
        if (room) {
          room.disconnect();
          try {
            const url = `https://twilio.alive.vision/rooms/${room.sid}?status=completed`;
            //const url = `http://localhost:3600/rooms/${room.sid}?status=completed`;
            fetch(url, {
              method: 'POST',
            });
          } catch (error) {
            console.error(error);
          }
        }
      }
    }
  }, [user, timer, room]);

  const handleLogout = useCallback(() => {
    mounted.current &&
      setRoom((prevRoom: any) => {
        if (prevRoom) {
          prevRoom.localParticipant.tracks.forEach((trackPub: any) => {
            trackPub.track.stop();
          });
          prevRoom.disconnect();
        }
        return null;
      });
  }, []);

  useEffect(() => {
    if (room) {
      const tidyUp = (event: any) => {
        if (event.persisted) {
          return;
        }
        if (room) {
          handleLogout();
        }
      };
      window.addEventListener('pagehide', tidyUp);
      window.addEventListener('beforeunload', tidyUp);
      return () => {
        window.removeEventListener('pagehide', tidyUp);
        window.removeEventListener('beforeunload', tidyUp);
      };
    }
  }, [room, handleLogout]);

  const participantsLimit = user?.data.trialSpecs.active
    ? user.data.trialSpecs.maxMeetingUsers
    : 1000;

  if (timer === 30) {
    alert('Faltam 30 segundos para terminar a chamada');
  }

  return (
    <>
      {room && (
        <Room
          room={room}
          handleLogout={handleLogout}
          live={live}
          participantsLimit={participantsLimit}
        />
      )}{' '}
      {timer && <div className="timer">{new Date(timer * 1000).toISOString().substr(11, 8)}</div>}
    </>
  );
};

export default VideoChat;
